var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"asd20-badge"}},[(_vm.visible)?_c('div',{staticClass:"asd20-badge",class:_vm.classes},[(!!_vm.$slots.default || _vm.value)?_c('div',{staticClass:"asd20-badge__content"},[_vm._v("\n      "+_vm._s(_vm.value)+"\n      "),_vm._t("default")],2):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }